
    <template>
    <div>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_reviews" autocomplete="off">
                <v-layout row wrap>
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="users" v-model="reviews.user_id" outlined  item-text="user_id"
                            item-value="user_id" :return-object="false" :label="$store.getters.lang.data.user_id">
                        </v-select>
                        </v-flex>
            
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="items" v-model="reviews.item_id" outlined  item-text="item_id"
                            item-value="item_id" :return-object="false" :label="$store.getters.lang.data.item_id">
                        </v-select>
                        </v-flex>
            
        <v-flex xs12 lg2 xl2 md3 sm4>
        <v-text-field v-model="reviews.review_value" type="number" :label="$store.getters.lang.data.review_value" outlined
            class="mx-1"  required rounded>
        </v-text-field>
    </v-flex>


        <v-flex xs12 lg2 xl2 md3 sm4>
        <v-text-field v-model="reviews.review_date" type="date" :label="$store.getters.lang.data.review_date" outlined
            class="mx-1"  required rounded>
        </v-text-field>
    </v-flex>


    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large >{{$store.getters.lang.data.add_btn}} reviews</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                        {{$store.getters.lang.data.reviews}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="review_id">
                                <template v-slot:[`item.review_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_reviews(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/reviews-list/'+item.review_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                    {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_reviews(selected_reviews.review_id)">
                    {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/reviews'
    export default {
        data() {
            return {
                reviews: {},
                search: '',
                loading : true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_reviews: {},
                delete_dialog: false,
                headers: [
                    
        {
            text: this.$store.getters.lang.data.review_id,
            align: 'start',
            sortable: true,
            value: 'review_id',
        },


        {
            text: this.$store.getters.lang.data.user_id,
            align: 'start',
            sortable: true,
            value: 'user_id',
        },


        {
            text: this.$store.getters.lang.data.item_id,
            align: 'start',
            sortable: true,
            value: 'item_id',
        },


        {
            text: this.$store.getters.lang.data.review_value,
            align: 'start',
            sortable: true,
            value: 'review_value',
        },


        {
            text: this.$store.getters.lang.data.review_date,
            align: 'start',
            sortable: true,
            value: 'review_date',
        },


                ],
            }
        },
        computed: {
            rows(){
                return this.$store.getters.reviews
            },
            
                    users (){
                        return this.$store.getters.users
                    },
                    
                    items (){
                        return this.$store.getters.items
                    },
                    
            
        },
        mounted(){
            this.read_reviews();
        },
        methods: {
            add_reviews() {
                controller.add_reviews(this.reviews).then(r => {
                    if (r.data) {
                        this.reviews = {}
                        this.$store.state.reviews.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'reviews Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add reviews',
                            color: 'error'
                        }
                    }
                })
            },
            delete_reviews(review_id) {
                controller.delete_reviews(review_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.reviews = this.$store.state.reviews.filter(f =>{
                            return f.review_id != review_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'reviews Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_reviews() {
                this.loading = true
                controller.get_reviews().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_reviews(i) {
                this.selected_reviews = i
                this.delete_dialog = true
            },
        },
    }
</script>
